<div class="flex" (click)="changeState($event)">
  <label [ngClass]='{ "checked": checked }' [class]="cssClass"></label>
  <div class="content" [class]="contentCssClass"><ng-content></ng-content></div>
</div>